import { Filter } from "../applied_filter/filter";
import { AvailabilityFilter } from "./availability_filter";
import { BooleanParametersFilter } from "./boolean_parameters_filter";
import { BrandFilter } from "./brand_filter";
import { FreeShippingFilter } from "./free_shipping_filter";
import { ParametersFilter } from "./parameters_filter";
import { PriceFilter } from "./price_filter";

export const categoryFilters: Filter[] = [
  AvailabilityFilter,
  FreeShippingFilter,
  PriceFilter,
  BrandFilter,
  ParametersFilter,
  BooleanParametersFilter,
];
